<template>
  <div>
    <v-divider></v-divider>
    <div
      class="p-5 overflow-auto max-h-[100vh]"
      v-if="teamWithNoBranch.length || branches.length"
    >
      <div v-show="isFeatureVisible('CREATE_DIRECT_TEAMS')">
        <p class="font-semibold mt-2" v-if="branches.length">Direct Teams</p>
        <div class="flex justify-between mb-6">
          <div>
            <v-chip
              v-for="(team, index) in teamWithNoBranch"
              :key="index"
              label
              small
              class="border border-black mr-3 my-2"
            >
              <span class="pr-2 text-black">
                {{ team?.teamName }}
              </span>
              <v-icon
                small
                @click="confirmRemoveTeam(team, index)"
                color="red"
                class="ml-2"
              >
                $delete
              </v-icon>
              <v-icon
                small
                @click="editItem(team, index, '')"
                color="green"
                class="ml-1"
              >
                $edit
              </v-icon>
            </v-chip>
          </div>
          <v-btn :color="$vuetify.theme.currentTheme.primary"
            class="white--text" small @click="drawer = true">
            Create new team
          </v-btn>
        </div>
      </div>

      <div v-show="isFeatureVisible('CREATE_BRANCH_TEAMS')">
        <v-divider></v-divider>
        <p class="font-semibold mt-6" v-if="branches.length">Branch Teams</p>
        <v-list>
          <v-list-item-group>
            <v-list-item
              v-for="(branch, index) in branches"
              :key="index"
              class="space-x-4 border border-blue-200 h-14"
              v-show="branch._id"
            >
              <v-label class=""> {{ index + 1 }}. </v-label>
              <p class="mb-0">
                {{ branch.branchName }}
              </p>

              <v-chip
                v-for="(team, teamIndex) in getTeamsByBranch(branch._id)"
                :key="teamIndex"
                label
                small
                class="border border-black"
              >
                <span class="pr-2 text-black">
                  {{ team.teamName }}
                </span>
                <v-icon
                  small
                  @click="confirmRemoveTeam(team, teamIndex)"
                  color="red"
                  class="ml-2"
                >
                  $delete
                </v-icon>
                <v-icon
                  small
                  @click="editItem(team, teamIndex, branch)"
                  color="green"
                  class="ml-1"
                >
                  $edit
                </v-icon>
              </v-chip>
              <div class="flex justify-end">
                <v-btn
                  text
                  :color="$vuetify.theme.currentTheme.primary"
                  @click="addNewTeam(branch)"
                  v-show="isFeatureVisible('LINK_TEAM_WITH_BRANCH')"
                  >Create new team</v-btn
                >
              </div>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
    </div>
    <no-data
      v-else
      title="Nothing to Display"
      :subTitle="`No active team enabled for the organization`"
      :btnText="`Create new team`"
      :btnAction="openDrawer"
    />
    <v-navigation-drawer
      :color="$vuetify.theme.currentTheme.navigationColor"
      class="teams-drawer"
      width="50%"
      height="100vh"
      v-model="drawer"
      absolute
      right
    >
      <div class="overflow-auto">
        <v-card-title class="text-h6 justify-center">
          Add/Edit Team
        </v-card-title>
        <div class="p-4 border flex justify-between">
          <div class="mt-2 w-full">
            <v-text-field
              class="px-8"
              v-model="selectedTeamName"
              label="Team Name *"
              dense
              outlined
              hide-details
            ></v-text-field>
            <v-textarea
              class="px-8 mt-3"
              v-model="selectedTeamDescription"
              label="Description"
              dense
              outlined
              hide-details
              rows="3"
            ></v-textarea>
            <v-autocomplete 
              class="px-8 mt-3"
              v-model="selectedNumber" 
              :items="phoneNumbers" 
              item-text="phoneNumber" 
              item-value="_id" 
              outlined
              dense 
              hide-details 
              label="link telecaller virtual number" 
            >
            </v-autocomplete>
          </div>
        </div>
        <div class="flex justify-end mr-4 mt-4">
          <v-btn @click="cancel" class="mr-2" outlined>Cancel</v-btn>
          <v-btn @click="saveTeam" :color="$vuetify.theme.currentTheme.primary"
            class="white--text">Save</v-btn>
        </div>
        <AlertPopUp
          :showConfirmationDialog="showConfirmationDialog"
          :confirmationTitle="'Confirm Delete'"
          :confirmationMessage="'Are you sure you want to delete the team?'"
          :confirmationActionText="'Delete'"
          :confirmationActionColor="'red'"
          :performAction="teamDelete"
          :cancel="cancel"
        />
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import AlertPopUp from "@/components/AlertPopUp";
import NoData from "@/components/NoData";
import { isModuleFeatureAllowed } from "@/utils/common";
export default {
  components: {
    AlertPopUp,
    NoData,
  },
  props: {
    branches: Array,
  },
  data() {
    return {
      drawer: false,
      teams: [{ teamName: "", teamDescription: "" }],
      showConfirmationDialog: false,
      selectedTeam: null,
      selectedBranch: null,
      selectedTeamName: "",
      selectedTeamDescription: "",
      selectedNumber: "",
      phoneNumbers: []
    };
  },
  computed: {
    teamWithNoBranch() {
      return this.teams.filter((el) => !el.branch);
    },
  },
  methods: {
    async getVoiceNumbers() {
      try {

        const response = await this.$axios.get("/workforce/tele-caller/credentials");
        if (response.data.success) {
          this.phoneNumbers = response?.data?.data
        }

      } catch (error) {
        console.log(error);
      }
    },
    isFeatureVisible(feature) {
      return isModuleFeatureAllowed("TEAM_MANAGEMENT", feature);
    },
    openDrawer() {
      this.drawer = true;
    },
    addNewTeam(branch) {
      this.selectedTeamName = "";
      this.selectedTeamDescription = "";
      this.drawer = true;
      this.selectedBranch = branch;
      this.selectedNumber = ""
    },
    editItem(team, teamIndex, branch) {
      this.selectedTeam = team;
      this.selectedBranch = branch;
      this.selectedTeamName = team.teamName;
      this.selectedTeamDescription = team.teamDescription;
      this.selectedNumber = team.connectVirtualNumber
      this.drawer = true;
    },
    confirmRemoveTeam(team) {
      this.selectedTeam = team;
      this.showConfirmationDialog = true;
    },
    cancel() {
      this.drawer = false;
      this.selectedTeamName = "";
      this.selectedTeamDescription = "";
      this.showConfirmationDialog = false;
      this.selectedTeam = null;
      this.selectedBranch = null;
      this.selectedNumber = ""
    },
    async teamDelete() {
      const team = this.selectedTeam;
      try {
        if (!team?._id) {
          return;
        }
        const response = await this.$axios.delete(`/workforce/team/${team._id}`);
        await this.fetchTeams();
        const successMessage = response?.data?.message || "Team deleted successfully"
        this.$toast.success(successMessage);
        this.showConfirmationDialog = false;
        this.selectedTeam = null;
      } catch (error) {
        console.error("Error deleting team:", error);
        const errorMessage = error.response.data.message || error
        this.$toast.error(errorMessage);
      }
    },
    getTeamsByBranch(branchId) {
      if (!branchId) return;
      return this.teams.filter((team) => team.branch === branchId);
    },
    async fetchTeams() {
      try {
        const response = await this.$axios.get("/workforce/teams");
        this.teams = response.data.teams.map((team) => ({
          ...team,
          disabled: true,
        }));
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    },
    async updateTeam(team) {
      try {
        const payload = {
          teamName: this.selectedTeamName,
          teamDescription: this.selectedTeamDescription,
          connectVirtualNumber: this.selectedNumber
        };
        const response = await this.$axios.put(`/workforce/team/${team._id}`, payload);
        const successMessage = response?.data?.message || "Team Updated successfully"
        this.$toast.success(successMessage);
      } catch (error) {
        console.error("Error updating team:", error);
        const errorMessage = error.response.data.message || error
        this.$toast.error(errorMessage);
      }
    },
    async createTeam() {

      if(!this.selectedTeamName) {
        this.$toast.error("Team name not filled.")
        return;
      }

      try {
        let teamPayload;
        if (this.selectedBranch?._id) {
          teamPayload = [
            {
              teamName: this.selectedTeamName,
              teamDescription: this.selectedTeamDescription,
              branch: this.selectedBranch?._id,
              connectVirtualNumber: this.selectedNumber
            },
          ];
        } else {
          teamPayload = [
            {
              teamName: this.selectedTeamName,
              teamDescription: this.selectedTeamDescription,
              connectVirtualNumber: this.selectedNumber
            },
          ];
        }
        const response = await this.$axios.post(
          "/workforce/team",
          teamPayload,
        );
        const successMessage = response?.data?.message || "Team Created successfully"
        this.$toast.success(successMessage);
      } catch (error) {
        console.log(error);
        const errorMessage = error.response.data.message || error
        this.$toast.error(errorMessage);
      }
    },
    async saveTeam() {
      if (this.selectedTeam) {
        await this.updateTeam(this.selectedTeam);
      } else {
        await this.createTeam();
      }
      await this.fetchTeams();
      this.drawer = false;
      this.selectedTeam = null;
      this.selectedTeamName = "";
      this.selectedBranch = null;
      this.selectedTeamDescription = "";
      this.selectedNumber = ""
    },
  },
  async mounted() {
    this.fetchTeams();
    await this.getVoiceNumbers()
  },
};
</script>

<style>
.teams-drawer {
  border: 1px solid rgb(199 199 199) !important;
}
</style>
